module.exports = __webpack_public_path__ + "img/4bombas.9a23b52b.jpg";